import utils from '@eitje/utils'
import {ROLES} from '~/roles'

const DEFAULT_TIME_REGISTRATION_HOUR_TYPES = [
	{id: 'gewerkte_uren', labelKey: 'worked'},
	{id: 'ziek', labelKey: 'sick', requiredRole: ROLES.approveHours},
	{id: 'verlof', labelKey: 'leave', requiredRole: ROLES.leave},
	{id: 'bijzonder_verlof', labelKey: 'special_leave', requiredRole: ROLES.approveHours},
]

const getRequiredRoleState = ({hourType, environmentIds, roleEnvironmentIdsByRole}) => {
	if (!hourType.requiredRole)
		return {
			isDisabled: false,
			missingRequiredRoleEnvironmentIds: [],
		}

	const roleEnvironmentIds = roleEnvironmentIdsByRole[hourType.requiredRole]

	if (!roleEnvironmentIds) {
		throw new Error(`Missing role environment context for role ${hourType.requiredRole}`)
	}

	const scopedEnvironmentIds = utils.alwaysDefinedArray(environmentIds).uniq()
	const missingRequiredRoleEnvironmentIds = scopedEnvironmentIds.filter(environmentId => !roleEnvironmentIds.includes(environmentId))

	const isDisabled = scopedEnvironmentIds.length ? missingRequiredRoleEnvironmentIds.length > 0 : roleEnvironmentIds.length === 0

	return {isDisabled, missingRequiredRoleEnvironmentIds}
}

export const getTimeRegistrationHourTypeOptions = ({
	environmentIds,
	hourTypes = DEFAULT_TIME_REGISTRATION_HOUR_TYPES,
	roleEnvironmentIdsByRole = {},
} = {}) => {
	return hourTypes.map(hourType => {
		const requiredRoleState = getRequiredRoleState({hourType, environmentIds, roleEnvironmentIdsByRole})

		return {...hourType, ...requiredRoleState}
	})
}
